/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query CustomerFinancialQuery(
    $customerId: ID
    $smsStartDate: DateTime!
    $smsEndDate: DateTime!
    $take: PositiveInt
    $skip: Int
  ) {
    CustomerFinancial(
      customerId: $customerId
      smsStartDate: $smsStartDate
      smsEndDate: $smsEndDate
      take: $take
      skip: $skip
    ) {
      status
      message
      totalCount
      CustomerRead {
        id
        displayName
        totalCost
        totalMargin
        totalRevenue
      }
    }
  }
`;
